<template>
    <div class="input-group" :class="computedClasses">
        <div class="input-group-prepend">
            <span
                class="input-group-text"
                :class="{...activeClass, ...labelClass}"
            >
                <slot />
            </span>
        </div>
        <input
            :id="id"
            v-model.trim="valueCopy"
            :type="type"
            data-toggle="tooltip-city"
            class="form-control"
            :class="inputClasses"
            :name="name"
            :placeholder="placeholder"
            :title="title"

            :readonly="readonly"
            :disabled="disabled"
            :autocomplete="autocomplete"

            :max="max"
            :min="min"
            :step="step"
            :minlength="minlength"
            :maxlength="maxlength"
            :required="required"

            @focus="handleFocus(true)"
            @blur="handleFocus(false)"
            @input="handleModelInput"
            @keydown.down="onKeyDown"
            @keydown.up="onKeyUp"
            @keydown.enter="onKeyEnter"
            @keydown.tab="onKeyEnter"
        >
    </div>
</template>

  <script>
    export default {
        name: 'SimpleGroupInput',
        props: {
            id: {
                type: String,
                default: null
            },
            name: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: 'text'
            },
            value: {
                default: null
            },
            placeholder: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            readonly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            min: {
                type: [String, Number],
                default: null
            },
            max: {
                type: [String, Number],
                default: null
            },
            step: {
                type: Number,
                default: null
            },
            minlength: {
                type: Number,
                default: null
            },
            maxlength: {
                type: Number,
                default: null
            },
            required: {
                type: Boolean,
                default: false
            },
            autocomplete: {
                type: String,
                default: 'off',
            },
            inputClasses: {
                type: [Array, Object, String],
                default: null
            },
            labelClass: {
                type: Object,
                default: () => { return {}; },
            },
        },
        data() {
            return {
                valueCopy: null,
                focus: false,
                valid: true
            };
        },
        beforeMount() {
            // Here we are following the Vue2 convention on custom v-model:
            // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
            this.copyValue(this.value);
        },
        mounted() { },
        computed: {
            computedClasses() {
                return {
                    'material--active': this.focus,
                    'material--disabled': this.disabled,
                    'material--raised': Boolean(this.focus ||
                        this.hasValue || // has value
                        (this.placeholder && !this.hasValue)) // has placeholder
                };
            },
            activeClass() {
                return {
                    'active': Boolean(this.focus ||
                        this.hasValue || // has value
                        (this.placeholder && !this.hasValue)) // has placeholder
                };
            },
            hasValue() {
                return this.valueCopy != undefined && this.valueCopy != null && (this.valueCopy + '').trim() !== '';
            },
        },
        watch: {
            value(newValue) {
                // This watch works from the code side of the 2-way-binding:
                this.copyValue(newValue);
            }
        },
        methods: {
            handleModelInput(event) {
                this.$emit('input', event.target.value, event);
                this.handleValidation();
            },
            handleFocus(focused) {
                if (!(this.disabled || this.readonly)) {
                    this.focus = focused;
                }
            },
            handleValidation() {
                // this.valid = this.$el ? this.$el.querySelector('.form-control').validity.valid : this.valid;
            },
            copyValue(value) {
                this.valueCopy = value;
                this.handleValidation();
            },
            onKeyDown(event) {
                this.$emit('keyDown', event);
            },
            onKeyUp(event) {
                this.$emit('keyUp', event);
            },
            onKeyEnter(event) {
                this.$emit('keyEnter', event);
            },
        }
    }
  </script>